/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppropriationLine } from './AppropriationLine';
import {
    AppropriationLineFromJSON,
    AppropriationLineFromJSONTyped,
    AppropriationLineToJSON,
} from './AppropriationLine';

/**
 * The DTO representation of the appropriation in the occ layer.
 * @export
 * @interface Appropriation
 */
export interface Appropriation {
    /**
     * 
     * @type {string}
     * @memberof Appropriation
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof Appropriation
     */
    status?: AppropriationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Appropriation
     */
    group?: AppropriationGroupEnum;
    /**
     * 
     * @type {Date}
     * @memberof Appropriation
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Appropriation
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Appropriation
     */
    contractProductsOnlyForProductGroup?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appropriation
     */
    mainCustomerUserUid?: string;
    /**
     * 
     * @type {Array<AppropriationLine>}
     * @memberof Appropriation
     */
    lines?: Array<AppropriationLine>;
    /**
     * 
     * @type {string}
     * @memberof Appropriation
     */
    appropriationGroupType?: AppropriationAppropriationGroupTypeEnum;
}


/**
 * @export
 */
export const AppropriationStatusEnum = {
    Released: 'RELEASED',
    Revised: 'REVISED',
    Planned: 'PLANNED',
    Cancelled: 'CANCELLED',
    Closed: 'CLOSED',
    Rejected: 'REJECTED',
    Won: 'WON',
    Lost: 'LOST'
} as const;
export type AppropriationStatusEnum = typeof AppropriationStatusEnum[keyof typeof AppropriationStatusEnum];

/**
 * @export
 */
export const AppropriationGroupEnum = {
    Nutrition: 'NUTRITION',
    Miscellaneous: 'MISCELLANEOUS',
    Incontinence: 'INCONTINENCE',
    Diabetes: 'DIABETES',
    DiabetesType1: 'DIABETES_TYPE_1',
    DiabetesType2: 'DIABETES_TYPE_2',
    Ostomy: 'OSTOMY',
    Respiratory: 'RESPIRATORY',
    Stockings: 'STOCKINGS',
    DietarySupplements: 'DIETARY_SUPPLEMENTS',
    HalfNutrition: 'HALF_NUTRITION',
    FullNutrition: 'FULL_NUTRITION',
    GlutenProduct: 'GLUTEN_PRODUCT',
    Deductible: 'DEDUCTIBLE',
    Nursing: 'NURSING',
    AccessoriesNutrition: 'ACCESSORIES_NUTRITION',
    Cvk: 'CVK',
    Unknown: 'UNKNOWN'
} as const;
export type AppropriationGroupEnum = typeof AppropriationGroupEnum[keyof typeof AppropriationGroupEnum];

/**
 * @export
 */
export const AppropriationAppropriationGroupTypeEnum = {
    GreenOrdination: 'GREEN_ORDINATION',
    Appropriation: 'APPROPRIATION'
} as const;
export type AppropriationAppropriationGroupTypeEnum = typeof AppropriationAppropriationGroupTypeEnum[keyof typeof AppropriationAppropriationGroupTypeEnum];


/**
 * Check if a given object implements the Appropriation interface.
 */
export function instanceOfAppropriation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppropriationFromJSON(json: any): Appropriation {
    return AppropriationFromJSONTyped(json, false);
}

export function AppropriationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Appropriation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'contractProductsOnlyForProductGroup': !exists(json, 'contractProductsOnlyForProductGroup') ? undefined : json['contractProductsOnlyForProductGroup'],
        'mainCustomerUserUid': !exists(json, 'mainCustomerUserUid') ? undefined : json['mainCustomerUserUid'],
        'lines': !exists(json, 'lines') ? undefined : ((json['lines'] as Array<any>).map(AppropriationLineFromJSON)),
        'appropriationGroupType': !exists(json, 'appropriationGroupType') ? undefined : json['appropriationGroupType'],
    };
}

export function AppropriationToJSON(value?: Appropriation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalId': value.externalId,
        'status': value.status,
        'group': value.group,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'contractProductsOnlyForProductGroup': value.contractProductsOnlyForProductGroup,
        'mainCustomerUserUid': value.mainCustomerUserUid,
        'lines': value.lines === undefined ? undefined : ((value.lines as Array<any>).map(AppropriationLineToJSON)),
        'appropriationGroupType': value.appropriationGroupType,
    };
}

